import Vue from 'vue';
import VueI18n from 'vue-i18n';

export function useI18n() {
  return Vue['i18n'] as VueI18n;
}
